import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { TenantProvider } from "./context/TenantContext";
import { ThemeProvider } from "./context/ThemeContext";
import {
  NotificationProvider,
  useNotification,
} from "./context/NotificationContext";
import { NetworkStatusProvider } from "./context/NetworkStatusContext";
import { setNotificationHandler } from "./services/api";
import { setUniAdminNotificationHandler } from "./services/university-admin/api";
import AppRoutes from "./routes/AppRoutes";
import NotificationContainer from "./components/common/NotificaitonContainer";

// Import Font Awesome for icons (Bootstrap CSS comes via main.scss)
import "@fortawesome/fontawesome-free/css/all.min.css";

// Import i18n configuration - initializes i18next
import "./i18n/config";

// Component to set up notification handler
const NotificationSetup = () => {
  const notification = useNotification();

  useEffect(() => {
    setNotificationHandler(notification);
    setUniAdminNotificationHandler(notification);
  }, [notification]);

  return null;
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <NetworkStatusProvider>
          <NotificationProvider>
            <AuthProvider>
              <TenantProvider>
                <div className="App">
                  <NotificationSetup />
                  <AppRoutes />
                  <NotificationContainer />
                </div>
              </TenantProvider>
            </AuthProvider>
          </NotificationProvider>
        </NetworkStatusProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
